export default __webpack_public_path__ + "static/media/melanie.3d4f95c8.jpg";